import React, { useState } from "react";
import "./tools.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import UserTypChooice from "./UserTypChooice";

interface Props {
    onExit: () => void;
}

const CookieConfirmation = ({onExit}:Props) => {
    const [confirmedCookies,setConfirmedCookies] = useState<boolean>(false);

if (confirmedCookies === true){
    return     ( <div className="cookie-full">
        <UserTypChooice  onExit={onExit}/>
    </div>);
    
}

  return (
    <div className="cookie-full">
      <div
        className="modal show"
        style={{ display: "block", position: "initial" }}
      >
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>Cookie Confirmation</Modal.Title>
          </Modal.Header>

          <Modal.Body className="cookie-modal-max">
            <h3>Cookie and Data Storage Information</h3>

            <h3>What data do we collect?</h3>
            <p>
              When you visit our website, we may collect the following data:
            </p>
            <ol>
              <li>
                <strong>IP Address:</strong> This is the unique address which
                identifies your device on the internet. We use this information
                to gather broad demographic information, track user movement,
                and to improve our website.
              </li>
              <li>
                <strong>LocalStorage Data:</strong> LocalStorage is a web
                storage solution that allows websites to store data in a browser
                on a device. We use LocalStorage to enhance user experience and
                store preferences/settings for your subsequent visits.
              </li>
              <li>
                <strong>Cookies:</strong> A cookie is a small file which is
                stored on your computer or mobile device. We use cookies to
                retain user preferences, store information for things like
                shopping carts, and provide anonymised tracking data to
                third-party applications.
              </li>
            </ol>

            <h3>Why do we collect this data?</h3>
            <ol>
              <li>
                <strong>Enhanced User Experience:</strong> Storing certain
                pieces of information allows us to tailor the website to provide
                you with a personalized experience on subsequent visits.
              </li>
              <li>
                <strong>Analysis and Improvement:</strong> By tracking user
                movements and actions on our site, we can identify areas for
                improvement and enhance the overall user experience.
              </li>
              <li>
                <strong>Safety & Security:</strong> Collecting IP addresses can
                help us identify and prevent unauthorized access or potential
                security risks.
              </li>
            </ol>

            <h3>How can you manage or delete this data?</h3>
            <p>
              You can manage, restrict, or delete cookies and LocalStorage data
              via your browser settings. Each browser is different, so you may
              need to consult the 'Help' section of your browser or look at the
              aboutcookies.org website which offers guidance for all modern
              browsers.
            </p>
            <p>
              Please note: If you choose to disable cookies or LocalStorage, you
              are not able to use this site               
            </p>

            <h3>Your consent</h3>
            <p>
              By continuing to use our website, you consent to the processing of
              the described data. If you do not agree with our data collection
              practices, please refrain from using our website or adjust your
              browser settings accordingly.
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="primary" onClick={() => setConfirmedCookies(true)}>Confirm cookie use</Button>
          </Modal.Footer>
        </Modal.Dialog>
      </div>
    </div>
  );
};

export default CookieConfirmation;
